'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _Object$assign = _interopDefault(require('babel-runtime/core-js/object/assign'));
var _Object$keys = _interopDefault(require('babel-runtime/core-js/object/keys'));
var $ = _interopDefault(require('jquery'));
var Mailcheck = _interopDefault(require('mailcheck'));
var FREE_EMAIL_KEYWORDS = _interopDefault(require('../global/free-email-keywords.js'));
var Config = _interopDefault(require('../global/config.js'));
var QueryString = _interopDefault(require('../helpers/querystring.js'));
var URLHelper = _interopDefault(require('../helpers/url.js'));

function API() {
  this.passwordLength = 5;
  this.shopNameMinLength = 4;
  this.shopNameMaxLength = 60;
}

API.prototype.baseURI = function () {
  return Config.get('SignupBaseURI', 'https://app.shopify.com');
};

API.prototype.validatePresent = function (value) {
  var errors = {};
  if (!value) {
    errors.required = true;
  }
  return errors;
};

API.prototype.validateShopName = function (email, password) {
  var value = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

  var errors = {};
  var dfr = $.Deferred();
  var disallowedWords = this.shopNameHasDisallowedWords(value);

  if (value.length < this.shopNameMinLength) {
    errors.minlength = true;
    return dfr.resolve(errors);
  }

  if (value.length > this.shopNameMaxLength) {
    errors.maxlength = true;
    return dfr.resolve(errors);
  }

  if (value === password) {
    errors.matchesPassword = true;
    return dfr.resolve(errors);
  }

  if (disallowedWords) {
    errors.disallowed = disallowedWords;
    return dfr.resolve(errors);
  }

  return API.prototype.subdomainAvailable(value);
};

API.prototype.validateSubdomain = function (email, password, value, captcha_response) {
  var _this = this;

  // eslint-disable-line camelcase
  var response = {
    errors: {},
    subdomain: null
  };
  var dfr = $.Deferred();
  var data = {
    email: email,
    password: password,
    subdomain: value,
    captcha_response: captcha_response // eslint-disable-line camelcase
  };

  return $.ajax({
    url: this.baseURI() + '/services/find_subdomain.json',
    data: data,
    type: 'POST',
    xhrFields: {
      withCredentials: true
    }
  }).done(function (res) {
    if (res.subdomain) {
      response.subdomain = res.subdomain;
    } else {
      response.errors = _this.handleSubdomainError(res);
    }
    return dfr.resolve(response);
  });
};

API.prototype.subdomainAvailable = function (subdomain) {
  var dfr = $.Deferred();
  var disallowedWords = this.shopNameHasDisallowedWords(subdomain);

  if (disallowedWords) {
    return dfr.resolve({ disallowed: disallowedWords });
  }

  var errors = {};
  this.checkAvailability(subdomain, null).done(function (data) {
    if (data.status === 'unavailable') {
      errors.existingAdmin = data.host;
    } else if (data.status === 'error') {
      errors.message = data.message;
    }
    dfr.resolve(errors);
  });

  return dfr;
};

API.prototype.handleSubdomainError = function (data) {
  // possible responses: multiple, suggest, throttled
  var errors = {};

  if (_Object$keys(data).length) {
    errors = data;
  } else {
    errors.invalid = true;
  }

  return errors;
};

API.prototype.validateEmail = function (data) {
  var errors = {};

  if (!/^[a-z0-9_.\-+]+@[a-z0-9-.]+\.[a-z0-9]{2,}$/i.test(data)) {
    errors.invalid = true;
  }

  return errors;
};

API.prototype.validatePassword = function () {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  var errors = {};

  if (!/^[^\s].*[^\s]$/.test(data)) {
    errors.spaces = true;
    return errors;
  }

  if (data.length < this.passwordLength) {
    errors.minlength = true;
  }

  return errors;
};

API.prototype.checkAvailability = function (shopName, email) {
  return $.getJSON(this.baseURI() + '/services/signup/check_availability.json?callback=?', {
    shop_name: shopName, // eslint-disable-line camelcase
    email: email
  });
};

API.prototype.getLocation = function () {
  return window.location;
};

API.prototype.track = function (urlParams) {
  var params = void 0;

  if (urlParams) {
    params = urlParams;
  } else {
    params = QueryString.parse(URLHelper.querystring(this.getLocation().href));
  }

  params = _Object$assign({ signup_page: this.getLocation().href }, params); // eslint-disable-line camelcase

  delete params.callback;

  return $.getJSON(this.baseURI() + '/services/signup/track/?callback=?', params);
};

API.prototype.shopNameHasDisallowedWords = function (shopName) {
  var disallowedRegexp = /(shopify)/gi;
  var result = disallowedRegexp.exec(shopName);

  if (result) {
    return result[1];
  }

  return false;
};

API.prototype.isCustomEmail = function (email) {
  var emailDomain = email.match(/@(.*)\./).pop();

  return FREE_EMAIL_KEYWORDS.indexOf(emailDomain) === -1;
};

API.prototype.checkEmailTypo = function (email) {
  var dfr = $.Deferred();

  if (this.validateEmail(email).invalid) {
    dfr.reject();
  }

  Mailcheck.run({
    domains: [],
    secondLevelDomains: ['gmail', 'hotmail', 'yahoo'],
    topLevelDomains: ['at', 'be', 'biz', 'ca', 'ch', 'co.id', 'co.il', 'co.jp', 'co.nz', 'co.uk', 'co.za', 'com', 'com.au', 'com.co', 'com.mx', 'com.ng', 'com.ph', 'com.pt', 'com.sg', 'com.tw', 'cz', 'de', 'dk', 'edu', 'es', 'eu', 'fr', 'gov', 'gr', 'hk', 'hu', 'ie', 'in', 'info', 'io', 'it', 'jp', 'kr', 'mil', 'my', 'net', 'net.au', 'nl', 'no', 'org', 'pt', 'ru', 'se', 'sg', 'uk', 'us', 'ws', 'za'],
    email: email,
    suggested: function suggested(suggestion) {
      dfr.resolve({
        suggestion: suggestion
      });
    },
    empty: function empty() {
      dfr.reject();
    }
  });

  return dfr;
};

var formsApi = new API();

module.exports = formsApi;
